import { render, staticRenderFns } from "./DiscountTypeDetail.vue?vue&type=template&id=a15da80c"
import script from "../../../controllers/custom/discount_type/discount-type-detail.js?vue&type=script&lang=js&external"
export * from "../../../controllers/custom/discount_type/discount-type-detail.js?vue&type=script&lang=js&external"
import style0 from "./DiscountTypeDetail.vue?vue&type=style&index=0&id=a15da80c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports